import { z } from 'zod';
export const TEMPLATE_PLACEHOLDER_RE = /\{\{([a-zA-Z][a-zA-Z0-9_]*)\}\}/g;
export const templateVariableSourceSchema = z.enum(['lead', 'custom', 'system', 'ai_slot']);
export const templateVariableDefSchema = z.object({
    key: z.string().min(1).max(64),
    source: templateVariableSourceSchema,
    required: z.boolean().default(false),
});
export const templateVariablesSchema = z.array(templateVariableDefSchema);
/** Built-in merge keys from leadToMailVariables + common aliases. */
export const SYSTEM_LEAD_TEMPLATE_KEYS = new Set([
    'voornaam',
    'first_name',
    'company',
    'email',
]);
export function inferTemplateVariableSource(key) {
    if (key.startsWith('ai_'))
        return 'ai_slot';
    if (SYSTEM_LEAD_TEMPLATE_KEYS.has(key))
        return 'lead';
    if (key.startsWith('custom_'))
        return 'custom';
    return 'custom';
}
export function extractTemplatePlaceholders(...parts) {
    const keys = new Set();
    for (const part of parts) {
        if (!part)
            continue;
        for (const match of part.matchAll(TEMPLATE_PLACEHOLDER_RE)) {
            keys.add(match[1]);
        }
    }
    return [...keys].sort((a, b) => a.localeCompare(b));
}
export function extractPlaceholdersFromBlocks(blocks) {
    if (blocks == null)
        return [];
    try {
        return extractTemplatePlaceholders(JSON.stringify(blocks));
    }
    catch {
        return [];
    }
}
/** Merge auto-detected keys with prior schema (keeps required flags). */
export function buildTemplateVariablesSchema(keys, previous = []) {
    const prevByKey = new Map(previous.map((d) => [d.key, d]));
    return keys.map((key) => {
        const prev = prevByKey.get(key);
        if (prev)
            return prev;
        return {
            key,
            source: inferTemplateVariableSource(key),
            required: SYSTEM_LEAD_TEMPLATE_KEYS.has(key),
        };
    });
}
export function deriveRenderMode(fields) {
    if (fields.render_mode)
        return fields.render_mode;
    if (fields.body_blocks != null)
        return 'blocks';
    if (fields.body_html?.trim())
        return 'html';
    return 'text';
}
export function collectTemplateVariableKeys(fields) {
    const blockStr = fields.body_blocks != null ? JSON.stringify(fields.body_blocks) : undefined;
    return extractTemplatePlaceholders(fields.subject_template, fields.body_text_template, fields.body_html, blockStr);
}
export function missingRequiredTemplateVariables(schema, vars) {
    return schema
        .filter((v) => v.required && !String(vars[v.key] ?? '').trim())
        .map((v) => v.key);
}
export function emailTemplateContentChanged(before, after) {
    const fields = [
        'subject_template',
        'body_text_template',
        'body_html',
        'body_blocks',
        'render_mode',
    ];
    for (const f of fields) {
        if (after[f] === undefined)
            continue;
        const a = after[f];
        const b = before[f];
        if (f === 'body_blocks') {
            if (JSON.stringify(a ?? null) !== JSON.stringify(b ?? null))
                return true;
            continue;
        }
        if ((a ?? null) !== (b ?? null))
            return true;
    }
    return false;
}
//# sourceMappingURL=emailTemplateVariables.js.map